jQuery(document).ready(function($){
  $('.details-matter__details .matter-detail-item').hover(    
    function() {
      let item_count = $(this).data('index');
      console.log(item_count);
      // Mouse enters the element
      $('.matter-detail-spot[data-index='+item_count+']').addClass('active');
      $(this).addClass('active-item');
      
    },
    function() {
      let item_count = $(this).data('index');
      // Mouse leaves the element
      $(this).removeClass('active-item');
      $('.matter-detail-spot[data-index='+item_count+']').removeClass('active');
    }
  );
});